export default __webpack_public_path__ + "static/media/store.b1acdc27.png";